export default "__VITE_ASSET__DqoAgBfN__"